<template>
  <div class="tab">
    <h2 class="title">智慧营销体系</h2>
    <p
      class="item"
      :class="{ active: item.id == type }"
      v-for="item in list"
      :key="item.id"
      @click="jumpPages(item.url)"
    >
      {{ item.name }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    type: String,
  },
  data() {
    return {
      list: [
        {
          id: "spread",
          name: "智慧传播",
          url: "spread",
        },
        {
          id: "channel",
          name: "智慧渠道",
          url: "channel",
        },
        {
          id: "case",
          name: "智慧案场",
          url: "case",
        },
      ],
    };
  },
  methods: {
    jumpPages(url) {
      // console.log(url, "adad");
      this.$router.push({ name: "wisdomMarket", params: { type: url } });
    },
  },
  watch:{
    $route(to, from) {
      this.$router.go(0);
    },
  }
};
</script>

<style lang="stylus" scoped>
.tab {
  position: fixed;
  bottom: 350px;
  left: 100px;
  height: 180px;

  .title {
    font-size: 18px;
    font-weight: 800;
    color: #333333;
    line-height: 28px;
  }

  .item {
    position: relative;
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    line-height: 46px;
    cursor: pointer;
  }

  .item.active:before {
    position: absolute;
    top: 15px;
    left: -10px;
    content: '';
    width: 2px;
    height: 17px;
    background: #EDB50B;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/ColumnTab.vue